<nz-form-item>
  <nz-form-label>{{ correspondentBankCodeLabel }}</nz-form-label>
  <nz-form-control>
    <app-institution-autocomplete
      nzSize="large"
      [maxlength]="config.correspondentBankCodeMaxLength"
      [placeholder]="correspondentBankCodePlaceholder"
      (institutionSelected)="onInstitutionSelect($event)"
      [formControl]="correspondentBankCodeControl"
    ></app-institution-autocomplete>
  </nz-form-control>
</nz-form-item>

<nz-form-item>
  <nz-form-label translate>payment.receiverInfo.correspondentBank.name.label</nz-form-label>
  <nz-form-control>
    <input
      nz-input
      nzSize="large"
      type="text"
      [maxlength]="config.correspondentBankNameMaxLength"
      [placeholder]="'payment.receiverInfo.correspondentBank.name.placeholder' | translate: locale.language"
      [formControl]="correspondentBankNameControl"
    />
  </nz-form-control>
</nz-form-item>

@if (showAddressControl) {
<nz-form-item>
  <nz-form-label translate>payment.receiverInfo.correspondentBank.address.label</nz-form-label>
  <nz-form-control>
    <input
      nz-input
      nzSize="large"
      type="text"
      [maxlength]="config.correspondentBankAddressMaxLength"
      [placeholder]="'payment.receiverInfo.correspondentBank.address.placeholder' | translate: locale.language"
      [formControl]="correspondentBankAddressControl"
    />
  </nz-form-control>
</nz-form-item>
} @if (showIdentifierControl) {
<nz-form-item>
  <nz-form-label translate>payment.receiverInfo.correspondentBank.identifier.label</nz-form-label>
  <nz-form-control>
    <input nz-input nzSize="large" type="text" [formControl]="correspondentBankIdentifierControl" />
  </nz-form-control>
</nz-form-item>
}
